module.exports = __webpack_public_path__ + "static/media/profile.dbc6abed.png";